<!--
 * @author liuwenzhe
 * @module 专区页-攻略
 * @created at 2022-03-01
-->
<template>
    <g-bottom-drawer
        class="drawer__wrapper--ext"
        :visible="visible"
        :height="'auto'"
        @coverClick="closePanel"
    >
        <div class="strategy__wrapper">
            <div class="strategy__header">
                {{ gameName }}攻略索引
                <div class="header__close-ic" @click.stop="closePanel"></div>
            </div>
            <div class="category__wrapper">
                <div class="category__menu">
                    <div
                        v-for="(category, index) in categories" :key="index"
                        class="category__item"
                        @click.stop="onCategoryClick(category)"
                    >
                        <div class="category__name">{{ category.name }}</div>
                        <div class="category__count">{{ category.num }}</div>
                        <div class="category__arrow"></div>
                    </div>
                </div>
            </div>
        </div>
    </g-bottom-drawer>
</template>

<script>
// 事件：
//   @select: 参数为{name: '', num: ''}
// 参数
//   visible：可视状态，使用:visible.sync="xxx" 来绑定
//   gameName: 游戏名；
//   categories: [{name: '', num: ''}]
import GBottomDrawer from '../GBottomDrawer.vue';
import {eventBus} from '@/pages/zone/index';
import {ZONE_ANCHOR_TO_STRATEGY_TAG} from '@/common/js/Constant';
export default {
    components: {
        GBottomDrawer,
    },
    props: {
        visible: { // 控制展示
            type: Boolean,
            default: false,
        },
        gameName: { // 游戏名称：用于标题的展示
            type: String,
            default: '',
        },
        categories: { // 分类列表
            type: Array,
            default: () => [],
        },
    },
    setup(props, {emit}) {
        function closePanel() {
            emit('update:visible', false);
        }
        function onCategoryClick(category) {
            eventBus.$emit(ZONE_ANCHOR_TO_STRATEGY_TAG, category.name);
            closePanel();
        }
        return {
            closePanel,
            onCategoryClick,
        };
    },
};
</script>

<style lang="scss" scoped>
.drawer__wrapper--ext {
    border-radius: 0.386rem 0.386rem 0px 0px !important;
    overflow: hidden;
}
.strategy__wrapper {
    position: relative;
    font-family: sans-serif;
    width: 100%;
    display: flex;
    flex-direction: column;
    * {
        box-sizing: border-box;
    }
    .strategy__header {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 150px;
        width: 100%;
        background-color: #fff;
        border-radius: 39px 39px 0 0;
        font-size: 54px;
        color: #222222;
        font-weight: 600;
        .header__close-ic {
            position: absolute;
            right: 48px;
            width: 64px;
            height: 64px;
            background-size: 64px 64px;
            background-image: url("~public/assets/imgs/pop_ic_close.png");
        }
    }
    .category__wrapper {
        flex: 1;
        overflow: scroll;
        .category__menu {
            display: flex;
            flex-wrap: wrap;
            padding: 0 51px 24px;
            .category__item {
                margin-bottom: 36px;
                padding: 0 36px;
                width: 552px;
                height: 114px;
                background: #f8f8f8;
                border-radius: 27px;
                display: flex;
                align-items: center;
                display: flex;
                align-items: center;
                justify-content: space-between;
                &:nth-child(odd) {
                    margin-right: 36px;
                }
                .category__name {
                    font-size: 42px;
                    color: #222222;
                    width: 296px;
                    max-width: 296px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .category__count {
                    font-size: 42px;
                    color: #888888;
                    width: 133px;
                    max-width: 133px;
                    text-align: right;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .category__arrow {
                    width: 27px;
                    height: 27px;
                    background-size: 27px 27px;
                    background-image: url("~public/assets/imgs/ic_strategy_more.png");
                }
            }
        }
    }
}
</style>